<template>
  <div class="animated fadeIn">
    <b-row class="mt-3" >
      <b-col sm="12">
        <b-alert :show="pendingEmailConfirmation" variant="warning">É um prazer ter você no Sleeker. É hora de confirmar seu email - basta clicar no link que te enviamos.</b-alert>
      </b-col>
    </b-row>
    <b-row class="mt-3" >
      <b-col sm="12">
        <b-button @click="goToSearch()" variant="success" style="width: 100%;">Sair do tutorial e usar o {{whitelabelName}} agora!</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3" v-if="youtubeTutorial || (tutorials && tutorials.length)">
      <b-col v-for="tutorial in tutorials" v-bind:key="tutorial.youtube" md="6">
        <b-card>
          <div slot="header">
            <i class="fa fa-play-circle"></i> {{tutorial.title}}
          </div>
          <div class="text-center">
          <iframe v-bind:src="tutorial.youtube" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" style="max-width: 100%; width: 100%; height:410px;" allowfullscreen></iframe>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import service from "../service";


export default {
  name: 'Tutorial',
  data () {
    return {
      me: undefined,
      isMobileScreen: isMobile,
      tutorials:  [],
      pendingEmailConfirmation: false
    }
  },
  computed: {
    templateName() {
      return localStorage.templateName;
    },
    whitelabelName() {
      return localStorage.whitelabelName;
    },
    youtubeTutorial() {
      return localStorage.youtubeTutorial;
    }
  },
  methods: {
    goToSearch: function() {
      this.$router.push("/home");
    }
  },
  created() {
    service.getTutorials().then((result) => {
      if (result && result.tutorials && result.tutorials.length)
        this.tutorials = result.tutorials;
      }
    );

    service.getMe().then(me => {
      if (!me.emailConfirmationTime && me.subscription.status == 2) {
        this.pendingEmailConfirmation = true;
        this.me = me;
      }
    })
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.row-eq-height {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}
</style>
